import React, {useCallback} from 'react';
import AffiliatesCta from './AffiliatesCta';
import AffiliatesFaq from './AffiliatesFaq';
import AffiliatesFooter from './AffiliatesFooter';
import AffiliatesHeader from './AffiliatesHeader';
import AffiliatesHero from './AffiliatesHero';
import {ArrowIcon} from './AffiliatesIcons';
import AffiliatesProducts from './AffiliatesProducts';
import AffiliatesSteps from './AffiliatesSteps';
import AffiliatesWhy from './AffiliatesWhy';
import {PARTNER_REGISTER_URL} from './affiliatesLinks';
import {useAffiliatesPage} from './useAffiliatesPage';
import I18n from 'app/i18n';
import {ELEMENT_NOT_FOUND} from 'app/utils/Consts';

const AffiliatesLanding = (): React.ReactElement => {
    useAffiliatesPage();

    const handlePointerMove = useCallback((event: React.PointerEvent<HTMLDivElement>) => {
        const {target} = event;

        if (!(target instanceof Element)) {
            return;
        }

        const card = target.closest('.pcard, .wcard');

        if (!(card instanceof HTMLElement)) {
            return;
        }

        const rect = card.getBoundingClientRect();

        card.style.setProperty('--mx', `${event.clientX - rect.left}px`);
        card.style.setProperty('--my', `${event.clientY - rect.top}px`);
    }, []);

    return <div className="aff-page js" onPointerMove={handlePointerMove}>
        <AffiliatesHeader/>
        <main id="top">
            <AffiliatesHero/>
            <AffiliatesSteps/>
            <AffiliatesProducts/>
            <AffiliatesWhy/>
            <AffiliatesFaq/>
            <AffiliatesCta/>
        </main>
        <div className="mbar" id="mbar" aria-hidden="true">
            <a className="btn" href={PARTNER_REGISTER_URL} tabIndex={ELEMENT_NOT_FOUND}>
                <span>{I18n.t('affiliate.join')}</span>
                <ArrowIcon/>
            </a>
        </div>
        <AffiliatesFooter/>
    </div>;
};

export default AffiliatesLanding;
